export default function Plus(): React.ReactElement {
  return <span>&nbsp;+&nbsp;</span>
}
